import { Venue } from './../../interfaces/venue';
import { EnvironmentService } from './../environment/environment.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotyfService } from './../notyf/notyf.service';
import { ApiService } from './../api/api.service';
import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private _settings: any = {};
  private _venueSettings: any = {};
  private _mainAppSettings: any = {};
  

  private settingsSubject = new BehaviorSubject<any>(this._settings);
  settings$ = this.settingsSubject.asObservable();

  private mainAppSettingsSubject = new BehaviorSubject<any>(this._mainAppSettings);
  mainAppSettings$ = this.mainAppSettingsSubject.asObservable();

  private _timer;
  private onHomePage = true;

  constructor(
    private api: ApiService,
    private notyf: NotyfService, 
    private platform: Platform,
    private environment: EnvironmentService,
    private router: Router,
    
  ) { 
    this._settings = JSON.parse(localStorage.getItem('settings')) || this.environment.settings;

    this.settingsSubject = new BehaviorSubject<any>(this._settings);
    this.settings$ = this.settingsSubject.asObservable();

    this.api.base_url.subscribe((url) => {
      if(url !== null) {

        this.updateSettings();
      }
    });
  }

  private checkIfOnVenuePage() {
    return (this.router.url.indexOf('/venue/') > -1);
  }

  private checkIfOnHomePage() {
    return (this.router.url === '/');
  }

  private checkIfOnCheckoutPage() {
    return (this.router.url === '/checkout' || this.router.url === 'checkout');
  }

  async getPlatform(): Promise <string>{

    if(this.platform.is('mobileweb') || this.platform.is('desktop')){

      return 'web';

    }else if(this.platform.is('ios')){

      return 'ios';

    }else{

      return 'android';

    }

  }
  
  async updateSettings(venue_id = null) {
    let data = {};

    if (this.checkIfOnVenuePage() || this.checkIfOnCheckoutPage()) {
      let venue : Venue | null = null;
      let localStorageCurrentVenue = localStorage.getItem('current-venue')
      if(localStorageCurrentVenue){
        venue = JSON.parse(localStorageCurrentVenue);
        data['venue_id'] = venue.id;
      }
      
    }

    if(venue_id){
      data['venue_id'] = venue_id
    }

    const response = await this.api.post('/settings/venue', data).toPromise();

    if (response['success']) {
      if (this.checkIfOnVenuePage() || this.checkIfOnCheckoutPage()) {
        this._venueSettings = response['data'];

        // explicitly trigger the subject so observers can be updated when these are set
        this.settingsSubject.next(this._settings);

        this.setTimer();

        return this._venueSettings;
      } else {
        this._settings = response['data'];
        this.settingsSubject.next(this._settings);

        localStorage.setItem('settings', JSON.stringify(this._settings));
      }
    }

    this.setTimer();

    return this._settings;
  }
  
  async updateMainAppSettings() {
    const response = await this.api.post('/settings/main-app-settings').toPromise();
    if (response && response['data']) {
      this._mainAppSettings = response['data'];
      this.mainAppSettingsSubject.next(this._mainAppSettings);
      localStorage.setItem('main_app_settings', JSON.stringify(this._mainAppSettings));
    }
  }

  setTimer() {
    if (this._timer) {
      clearTimeout(this._timer);
    }

    this._timer = setTimeout(() => {
      this.updateSettings();
    }, 24 * 60 * 60 * 100);
  }

  getSettings(group: string = null) {
    if (group) {
      if (this.checkIfOnCheckoutPage() && typeof this._venueSettings !== 'undefined' && typeof this._venueSettings[group] !== 'undefined') {
        return this._venueSettings[group];
      }
      return this._settings[group] || this._settings;
    }
    return this._settings;
  }

  // getSetting(group: string, name: string) {
  //   if ((this.checkIfOnCheckoutPage() || this.checkIfOnVenuePage()) && typeof this._venueSettings !== 'undefined' && typeof this._venueSettings[group][name] !== 'undefined') {
  //     return this._venueSettings[group][name];
  //   }

  //   return typeof this._settings[group] !== 'undefined' && typeof this._settings[group][name] !== 'undefined' ? this._settings[group][name] : undefined;
  // }

  getSetting(group: string, name: string) {
    if (
      (this.checkIfOnCheckoutPage() || this.checkIfOnVenuePage()) &&
      this._venueSettings?.[group]?.[name] !== undefined
    ) {
      return this._venueSettings[group][name];
    }
  
    if (this._settings?.[group]?.[name] !== undefined) {
      return this._settings[group][name];
    }
  
    return undefined;
  }
  
}
